<template>
  <div class="comment-write bg-lightgray p-12 my-2 d-flex align-items-center">
    <user-profile-picture cssClass="user-icon" :userEmail="me.email" :userName="me.vorname + '' + me.nachname" />
    <div class="comment-form">
        <div class="input-group custom-search">
          <label :v-for="textFieldId" class="sr-only">Neuen Kommentar verfassen</label>
          <textarea
              :disabled="disabled"
              :id="textFieldId"
              v-model="kommentarText"
              type="text"
              rows="1"
              class="form-control custom-search-input w-100"
              :placeholder="placeholderText"
              v-on:keyup="checkInputLength()"
              ref="commentTa"
              :style="inputStyle"
          ></textarea>
          <textarea class="shadowTA" v-model="kommentarText" ref="shadow" tabindex="0"></textarea>
          <button class="btn btn-suche bg-white custom-search-button btn-textarea-search" @click="submitComment" :disabled="sendButtonDisabled" >
            <i class="fas fa-paper-plane f-24 text-azure"></i><span class="sr-only">Kommentar senden</span>
          </button>
        </div>
    </div>

  </div>
</template>
<script lang="ts">

import { MeDTO, CommentDTO } from '@/generated/openapi';
import MeService from '@/services/meService';
import commentService from '@/services/commentService';
import { defineComponent } from 'vue'
import UserProfilePicture from './UserProfilePicture.vue';


export default defineComponent({
  components: { UserProfilePicture },
  name: 'NewCommentBox',
  props: {
    threadId: String,
    parentThreadId: String,
    focusWhenShown: Boolean
  },
  emits: ['newComment'],
  data() {
    return {
      threadIdLocal: '',
      kommentarText: '',
      disabled: false,
      me: {} as MeDTO,
      inputHeight: '0'
    };
  },
  mounted() {
    if (this.threadId !== undefined) {
      this.threadIdLocal = this.threadId
    }

    MeService.getMe().then((me) => {
      this.me = me
    }).catch(() => {
      this.me = {}
    })
    this.autoGrowHeight()
    if(this.focusWhenShown) {
      this.focusCommentTa();
    }
  },
  computed: {
    textFieldId(): string {
      return 'tf-new-comment-' +  this.threadIdLocal
    },
    sendButtonDisabled(): boolean {
      return this.kommentarText.trim() === '' || this.disabled;
    },
    placeholderText(): string {
      return (this.parentThreadId === undefined) ? "Kommentieren ..." : "Antwort verfassen ..."
    },
    inputStyle(): { 'min-height': string } {
      return {
        'min-height': this.inputHeight
      }
    }
  },
  methods: {
    focusCommentTa() {
      if (this.$refs.commentTa) {
        const x = this.$refs.commentTa as HTMLTextAreaElement
        x.focus()
      }
    },
    submitComment() {
      if (this.kommentarText.trim() !== '') {
        this.disabled = true
        this.checkInputLength()
        const commentDto: CommentDTO  = {
          parentid: this.parentThreadId,
          body: this.kommentarText.trim()
        }
        commentService.setComment(this.threadIdLocal, commentDto).then(() => {
          this.kommentarText = ''
          this.$emit('newComment')
        }).finally(() => {
          this.disabled = false
          this.autoGrowHeight()
        })
      }
    },

    checkInputLength() {
      const maxCommentLength = 1000
      if (this.kommentarText.length > maxCommentLength) {
        this.kommentarText = this.kommentarText.substring(0,maxCommentLength)
      }
      this.autoGrowHeight();
    },

    autoGrowHeight() {
        if(this.$refs.commentTa) {
          const s = this.$refs.shadow as HTMLTextAreaElement;
          this.inputHeight = (s.scrollHeight +5)+"px";
        }
    }
  }

});
</script>
